import React, {Component} from 'react';
import '../css/Page.css';

class PageContatti extends Component {

    render() {
        return (
            <div className="page">
                <article>

                    <div className="contatti">
                        <p>AREAMULTISERVICE di Molinaro Francesco</p>
                        <p>Via Petrozza n&deg; 18 &ndash; 87046 - Montalto Uffugo (CS)</p>
                        <p>Cellulare: +39 329-8177540</p>
                        <p>E-mail: <a href="mailto:info@areamultiservice.it">info@areamultiservice.it</a> | <a href="mailto:serviziappalti@libero.it">serviziappalti@libero.it</a></p>
                        <p>Partita Iva: 03243210782</p>
                    </div>
                </article>
            </div>
        );
    }
}

export default PageContatti;


// WEBPACK FOOTER //
// ./src/page/js/PageContatti.js